import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(cfg => {
  // Rete di sicurezza: baseURL è già '/api'. Se una chiamata scrive per errore
  // '/api/...' (o 'api/...'), lo normalizziamo per evitare il doppio prefisso
  // '/api/api/...' → 404. Vale per URL relativi (non assoluti http).
  if (cfg.url && !/^https?:\/\//i.test(cfg.url)) {
    cfg.url = cfg.url.replace(/^\/?api\//, '/');
    if (!cfg.url.startsWith('/')) cfg.url = '/' + cfg.url;
  }
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

function emitToast(message, type = 'error') {
  window.dispatchEvent(new CustomEvent('eden-toast', { detail: { message, type } }));
}

function friendlyError(err) {
  const d = err.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => x.msg || JSON.stringify(x)).join(', ');
  if (typeof d === 'string') return d;
  const s = err.response?.status;
  if (!err.response) return 'Connessione assente o server non raggiungibile.';
  if (s === 403) return 'Non hai i permessi per questa operazione.';
  if (s === 404) return 'Risorsa non trovata.';
  if (s >= 500) return 'Errore del server. Riprova tra poco.';
  return 'Si è verificato un errore. Riprova.';
}

function clearSessionAndRedirect() {
  localStorage.removeItem('token');  localStorage.removeItem('refresh_token'); localStorage.removeItem('user');
  sessionStorage.removeItem('token'); sessionStorage.removeItem('user');
  if (window.location.pathname !== '/login') window.location.href = '/login';
}

// Single-flight: se più richieste falliscono insieme con 401, un solo /auth/refresh parte.
let refreshPromise = null;
function refreshAccessToken() {
  const rt = localStorage.getItem('refresh_token');
  if (!rt) return Promise.reject(new Error('no-refresh-token'));
  if (!refreshPromise) {
    refreshPromise = axios.post('/api/auth/refresh', { refresh_token: rt })
      .then(res => {
        localStorage.setItem('token', res.data.access_token);
        return res.data.access_token;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

api.interceptors.response.use(r => r, async err => {
  const status = err.response?.status;
  const cfg = err.config || {};
  const isRefreshCall = cfg.url && cfg.url.includes('/auth/refresh');

  if (status === 401 && !cfg._retried && !isRefreshCall && localStorage.getItem('refresh_token')) {
    // Tenta un rinnovo silenzioso una sola volta, poi ripete la richiesta originale.
    cfg._retried = true;
    try {
      const newToken = await refreshAccessToken();
      cfg.headers = cfg.headers || {};
      cfg.headers.Authorization = `Bearer ${newToken}`;
      return api(cfg);
    } catch (_) {
      clearSessionAndRedirect();
      return Promise.reject(err);
    }
  }

  if (status === 401) {
    clearSessionAndRedirect();
  } else if (!cfg.silent) {
    // Ogni errore (tranne 401) mostra un toast, salvo opt-out con { silent:true }
    emitToast(friendlyError(err), 'error');
  }
  return Promise.reject(err);
});

export default api;
